export default __webpack_public_path__ + "static/media/ikoni_imago.f48efe1a.svg";